import { Typography } from 'antd';
import { Avatar } from 'components/common';
import OmiChanelChatSourceIcon from 'components/omni-channel-chat/OmiChanelChatSourceIcon';
import dayjs from 'dayjs';
import React from 'react';
import { ChatSessionDto } from 'types';

type Props = {
  item: ChatSessionDto;
  onClick?: () => void;
};

const OmniChannelChatHistoriesSessionItem: React.FC<Props> = ({ item, onClick }) => {
  return (
    <div className='flex w-full cursor-pointer gap-6 px-6 pb-5 pt-4 hover:bg-backgroundColor4' onClick={onClick}>
      <div className='relative h-[44px] w-[44px]'>
        <Avatar key={item.chatSessionId} size={44} src={item.chat?.customerAvatar} name={item.chat?.customerName} />
        <div className='absolute -bottom-0.5 -right-0.5 flex items-center justify-center'>
          <OmiChanelChatSourceIcon size={16} source={item.chat?.source} />
        </div>
      </div>
      <div className='flex h-[44px] flex-1 flex-col justify-between'>
        <Typography.Text ellipsis className='font-semibold'>
          {item.chat?.customerName}
        </Typography.Text>
        <Typography.Text type='secondary'>
          {dayjs(item.createdAt).format('HH:mm')}{' '}
          {item.completedAt ? ` - ${dayjs(item.completedAt).format('HH:mm')}` : ''}
        </Typography.Text>
      </div>
    </div>
  );
};
export default OmniChannelChatHistoriesSessionItem;
